import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Activity, BarChart3, TrendingUp, DollarSign } from 'lucide-react';
import SalesReportBuilder from './SalesReportBuilder';
import ForecastingDashboard from './ForecastingDashboard';
import PipelineHealth from '../../pages/PipelineHealthDashboard';
import RevenueForecast from '../../pages/RevenueForecast';

export default function SalesReports() {
  const [tab, setTab] = useState('pipeline');

  return (
    <div className="space-y-4" data-testid="sales-reports">
      <div>
        <h1 className="text-xl font-bold">Sales Reports</h1>
        <p className="text-sm text-muted-foreground">Pipeline, analytics, and revenue forecasting</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="sales-report-tabs">
          <TabsTrigger value="pipeline" data-testid="tab-pipeline">
            <Activity className="w-3.5 h-3.5 mr-1.5" /> Pipeline Health
          </TabsTrigger>
          <TabsTrigger value="analytics" data-testid="tab-analytics">
            <BarChart3 className="w-3.5 h-3.5 mr-1.5" /> Sales Analytics
          </TabsTrigger>
          <TabsTrigger value="forecasting" data-testid="tab-forecasting">
            <TrendingUp className="w-3.5 h-3.5 mr-1.5" /> Forecasting
          </TabsTrigger>
          <TabsTrigger value="revenue" data-testid="tab-revenue">
            <DollarSign className="w-3.5 h-3.5 mr-1.5" /> Revenue
          </TabsTrigger>
        </TabsList>

        <TabsContent value="pipeline" className="mt-4">
          <PipelineHealth />
        </TabsContent>

        <TabsContent value="analytics" className="mt-4">
          <SalesReportBuilder />
        </TabsContent>

        <TabsContent value="forecasting" className="mt-4">
          <ForecastingDashboard />
        </TabsContent>

        <TabsContent value="revenue" className="mt-4">
          <RevenueForecast />
        </TabsContent>
      </Tabs>
    </div>
  );
}
